import { Directive, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Calendar } from 'primeng/calendar';

@Directive({
  selector: '[sigvCalendarTimeConfirmation]'
})
export class CalendarTimeConfirmationDirective  implements OnInit {
  constructor(
    private calendar: Calendar,
    private control: NgControl
  ) { }

  triggerValidator(): boolean{
    this.control.control?.markAsTouched();
    this.control.control?.markAsDirty();
    this.control.control?.updateValueAndValidity();
    return !!this.control.control?.valid;
  }

  ngOnInit(): void{
    this.calendar!.toggle =
    () => {
      if (!this.calendar!.inline){
        if (!this.calendar!.overlayVisible) {
            this.calendar!.showOverlay();
            this.calendar!.inputfieldViewChild.nativeElement.focus();
        } else {
          if (this.triggerValidator()){
            this.calendar!.hideOverlay();
          }
        }
      }
    };
  }

}
